import { PAGE as idPrefix } from '../../../constants/translates';

const messages = {
  [`${idPrefix}.welcome`]: 'Нас чекають великі справи',
  [`${idPrefix}.home`]: 'Головна',
  [`${idPrefix}.about`]: 'О нас'
};

export default messages;
